import { useTranslation } from 'react-i18next'

import { CaseItemHeader, CaseItemNotificationWrapper, CaseItemMembers } from 'App/components'
import { TCaseItemWrapperContainerProps } from 'App/containers'

export const CaseItemArchived = ({
  isOwner,
  caseData,
  memberList,
  loading,
  showModal
}: TCaseItemWrapperContainerProps) => {
  const {
    id,
    title,
    notificationCount,
    type,
    createdAt,
    updatedAt,
    status,
    classification,
    owner
  } = caseData

  const { t } = useTranslation()

  return (
    <CaseItemNotificationWrapper notificationCount={notificationCount}>
      <CaseItemHeader
        id={id}
        title={title}
        isOwner={isOwner}
        status={status}
        showModal={showModal}
        classification={classification.name}
        type={type}
        createdAt={createdAt}
        updatedAt={updatedAt}
        getUpdatedAtLabel={(date) => t('cases.list.item.archivedAt', { date })}
      />

      <CaseItemMembers memberList={memberList} owner={owner} loading={loading} />
    </CaseItemNotificationWrapper>
  )
}
